import React from 'react';


function ToDosError() {
  return (
    <p>There was an error :c </p>
  )
}

export { ToDosError };